import { useState, memo } from "react";
import axios from "axios";
import { HiUserAdd } from "react-icons/hi";
import { TiTick } from "react-icons/ti";
import { toast } from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import backarrow from "../assets/icon/arrow-right.svg";
import { motion } from "framer-motion";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

const icons = [
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
];

const staticBackgroundIcons = (() => {
  const rows = 5,
    cols = 11,
    arr = [];
  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      arr.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 12 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  return arr;
})();

const AnimatedBackground = memo(() => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {staticBackgroundIcons.map((item, i) => (
      <motion.div
        key={i}
        className="absolute text-white/50"
        style={{
          top: `${item.top}%`,
          left: `${item.left}%`,
          opacity: item.opacity,
        }}
        initial={{ scale: 0.5 }}
        animate={{
          x: [0, item.xOffset, 0],
          y: [0, item.yOffset, 0],
          scale: [0.5, 1, 0.5],
        }}
        transition={{
          duration: item.duration,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <item.Icon size={item.size} />
      </motion.div>
    ))}
  </div>
));

const AddStudent = () => {
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_URL;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [ContactNumber, setContactNumber] = useState("");
  const [National_Code, setNational_Code] = useState("");
  const [address, setAddress] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [dateValue, setDateValue] = useState(null);
  const [gender, setGender] = useState("");
  const [uploadimage, setUploadimage] = useState("");
  const [showuploadicon, setShowuploadicon] = useState(true);
  const [imageid, setImageid] = useState("");

  const handlechooseimage = () => document.getElementById("openimage")?.click();

  const handleuploadimage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setShowuploadicon(false);
    const formdata = new FormData();
    formdata.append("file", file);
    axios
      .post(`${API_BASE}/api/files/admin/upload-file`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        toast.success("تصویر با موفقیت آپلود شد");
        setImageid(res.data.data.fileId);
        setUploadimage(URL.createObjectURL(file));
      })
      .catch(() => {
        toast.error("خطا در آپلود");
        setShowuploadicon(true);
      });
  };

  const handleDateChange = (date) => {
    if (!date) {
      setDateValue(null);
      setBirthDate("");
      return;
    }

    const gregorianDate = date.toDate();
    const formattedDate = gregorianDate.toISOString().slice(0, 10);

    setDateValue(date);
    setBirthDate(formattedDate);
  };

  const handleaddstudent = async () => {
    if (!gender) return toast.error("لطفاً جنسیت را انتخاب کنید");
    try {
      await axios.post(
        `${API_BASE}/api/student/Add-Student`,
        {
          firstName,
          lastName,
          email: email || undefined,
          mobile,
          National_Code,
          address: address || undefined,
          gender,
          ContactNumber: ContactNumber || undefined,
          fatherName: fatherName || undefined,
          birthDate: birthDate || undefined,
          imageid: imageid || undefined,
        },
        { headers: { Authorization: localStorage.getItem("token") } }
      );
      toast.success("دانشجو با موفقیت اضافه شد");
      navigate("/Mainpage/StudentsInf");
    } catch {
      toast.error("خطا در افزودن دانشجو");
    }
  };

  if (!localStorage.getItem("token")) return <Navigate to="/" />;

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center p-4">
      <AnimatedBackground />

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-5 w-full max-w-xl mx-auto border border-white/30"
      >
        <div className="flex items-center justify-between mb-4">
          <img
            src={backarrow}
            alt="back"
            className="w-8 h-8 cursor-pointer hover:scale-110 transition"
            onClick={() => navigate(-1)}
          />
          <h2 className="text-xl font-bold text-gray-800">
            افزودن دانشجو جدید
          </h2>
          <div className="w-8" />
        </div>

        <div className="flex justify-center my-4">
          <div
            onClick={handlechooseimage}
            className="relative w-24 h-24 rounded-full border-[3px] border-gray-700 overflow-hidden cursor-pointer shadow-lg hover:scale-105 transition"
          >
            <input
              type="file"
              id="openimage"
              accept="image/*"
              className="hidden"
              onChange={handleuploadimage}
            />
            {showuploadicon ? (
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <HiUserAdd size={48} className="text-gray-600" />
              </div>
            ) : (
              <img
                src={uploadimage}
                alt="avatar"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>

        <div className="space-y-3 text-sm">
          <div className="grid grid-cols-2 gap-3">
            <Input
              value={firstName}
              setValue={setFirstName}
              placeholder="نام"
            />
            <Input
              value={lastName}
              setValue={setLastName}
              placeholder="نام خانوادگی"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Input
              value={fatherName}
              setValue={setFatherName}
              placeholder="نام پدر"
            />
            <Input value={email} setValue={setEmail} placeholder="ایمیل" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Input
              value={mobile}
              setValue={setMobile}
              placeholder="همراه"
              maxLength={11}
              onlyNumbers
            />
            <Input
              value={ContactNumber}
              setValue={setContactNumber}
              placeholder="اضطراری"
              maxLength={11}
              onlyNumbers
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Input
              value={National_Code}
              setValue={setNational_Code}
              placeholder="کد ملی"
              onlyNumbers
            />
            <div className="relative">
              <DatePicker
                value={dateValue}
                onChange={handleDateChange}
                calendar={persian}
                locale={persian_fa}
                format="YYYY/MM/DD"
                placeholder="تاریخ تولد"
                inputClass="w-full px-3 py-2.5 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 text-sm text-right bg-white/70"
              />
            </div>
          </div>

          {/* فیلد جنسیت */}
          <div className="grid grid-cols-2 gap-3">
            <div className="px-3 py-2.5 rounded-lg border-2 border-gray-400 focus-within:border-gray-700 bg-white/70 transition flex items-center">
              <span className="font-bold text-gray-800 text-sm ml-4">
                جنسیت:
              </span>
              <div className="flex items-center gap-5">
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <div
                    className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition ${
                      gender === "male"
                        ? "border-gray-800 bg-gray-800"
                        : "border-gray-500"
                    }`}
                    onClick={() => setGender("male")}
                  >
                    {gender === "male" && (
                      <TiTick className="text-white" size={14} />
                    )}
                  </div>
                  <span className="text-sm font-medium text-gray-800">مرد</span>
                </label>

                <label className="flex items-center gap-1.5 cursor-pointer">
                  <div
                    className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition ${
                      gender === "female"
                        ? "border-gray-800 bg-gray-800"
                        : "border-gray-500"
                    }`}
                    onClick={() => setGender("female")}
                  >
                    {gender === "female" && (
                      <TiTick className="text-white" size={14} />
                    )}
                  </div>
                  <span className="text-sm font-medium text-gray-800">زن</span>
                </label>
              </div>
            </div>

            <Input value={address} setValue={setAddress} placeholder="آدرس" />
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleaddstudent}
            className="w-full py-3.5 bg-gray-800 hover:bg-gray-900 text-white font-semibold rounded-lg shadow-lg transition text-base mt-3"
          >
            افزودن دانشجو
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

const Input = ({ value, setValue, placeholder, maxLength, onlyNumbers }) => (
  <input
    type="text"
    value={value}
    onChange={(e) => setValue(e.target.value)}
    placeholder={placeholder}
    maxLength={maxLength}
    onKeyDown={(e) =>
      onlyNumbers &&
      !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key) &&
      e.preventDefault()
    }
    className="w-full px-3 py-2.5 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium text-sm bg-white/70 transition"
  />
);

export default AddStudent;
